// @ts-nocheck

import classNames from 'classnames';
import * as React from 'react';
import { ImageService } from '../../../main/services/ImageService/ImageService';
import { ORGANIZATION_TEXT as TEXT } from '../../support/orgConstants';
type Props = {
  className?: string;
};
export default class NoOrgView extends React.PureComponent<Props> {
  render() {
    const { className } = this.props;
    return (
      <div className={classNames('flex-layout__screen', className)}>
        <div className="forbidden-view__container">
          <img className="forbidden-view__image" src={ImageService.getImageUrl('/static/images/ic_unavailablePage.svg')} />
          <div className="forbidden-view__title">{TEXT.NO_ORG_SCREEN.TITLE}</div>
          {!this.props.loading && (
            <div>
              <span>{TEXT.NO_ORG_SCREEN.BODY}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}
